// DEPENDENCIES ---------------------------------------------------------------- //

import React from 'react';
import DriverManagement from './DriverManagement';

// TYPES ---------------------------------------------------------------- //

interface DriversTabContentProps {
  customerIds: number[];
}

// COMPONENT ---------------------------------------------------------------- //

const DriversTabContent: React.FC<DriversTabContentProps> = ({ customerIds }) => {
  return <DriverManagement customerIds={customerIds} />;
};

// EXPORT ---------------------------------------------------------------- //

export default DriversTabContent;
